import React from 'react'
import {TimelineRowProps} from '@/pages/OnlinePayments/components/TimelineRow/props'
import styles from './styles.scss'

export const TimelineRow: React.FC<TimelineRowProps> = ({ label, children }) => (
    <div className={styles.timelineItemRow}>
        <div className={styles.timelineItemTitle}>{label}</div>
        <div>{children}</div>
    </div>
)
